function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _active_category_to_l;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Scrollbars from "react-custom-scrollbars";
import Button from "./button";
import IconButton from "./icon_button";
import QuantityEditor from "./quantity_editor";
import StatusTooltip from "./status_tooltip";
import Chip from "./chip";
import SubAccessoriesManager from "./subaccessories_manager";
import NotificationFeed from "./notification_feed";
import Skeleton from "./skeleton";
import SlotCapacities from "./slot_capactities";
import SlotChip from "./slot_chip";
import Tooltip from "./tooltip";
import ModalNotification from "./modal_notification";
var ModalContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(51, 51, 51, 0.5);\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n"])));

// I don't really know why the pixel density stuff is working, but it works :)
// This is needed to scale the modal in case there are some system zoom (150% on windows for instance).
var Container = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  max-width: 1020px;\n  width: 90%;\n  height: calc(100vh - 4em);\n  background-color: white;\n  color: #333333;\n  padding-top: 20px;\n  overflow-x: hidden;\n\n  @media (max-width: ", "px) {\n    width: 95%;\n  }\n\n  @media (-webkit-min-device-pixel-ratio: 1.35) {\n    transform: scale(.7);\n    height: calc((100vh * 1.3));\n    width: 130%;\n    max-width: calc(1020px * 1.3);\n    box-sizing: border-box;\n    margin-right: calc(-50% * 0.3);\n    margin-left: calc(-50% * 0.3);\n  }\n\n  @media (-webkit-min-device-pixel-ratio: 1.70) {\n    transform: scale(.6);\n    height: calc((100vh * 1.6));\n    width: 160%;\n    max-width: calc(1020px * 1.6);\n    box-sizing: border-box;\n    margin-right: calc(-50% * 0.6);\n    margin-left: calc(-50% * 0.6);\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var HeadWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 0px 40px;\n  @media (max-width: ", "px) {\n    padding: 0px 20px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var ImageAndHeadWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var TitleAndCloseWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var TitleWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  font-weight: 700;\n  @media (max-width: ", "px) {\n    flex-wrap: wrap;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var TitleType = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: #626469;\n  font-size: 16px;\n"])));
var CloseIcon = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  color: #A0A4A8;\n  cursor: pointer;\n  margin-right: -28px;\n  @media (max-width: ", "px) {\n    margin-right: -10px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var TitleLinkWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: 0px 5px;\n"])));
var CategoryTabsWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  margin-top: 10px;\n  box-sizing: border-box;\n  & :first-child {\n    margin-left: -1px;\n  }\n\n  @media (max-width: ", "px) {\n    margin-right: -20px;\n    margin-left: -20px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var CategoryTab = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex: 1 0 0px;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #CCCCCC;\n  cursor: pointer;\n  margin-right: -1px;\n  font-size: 18px;\n  color: #626469;\n\n  ", "\n  ", "\n  ", "\n\n  @media (max-width: ", "px) {\n    padding: 10px;\n    font-size: 16px;\n  }\n"])), function (props) {
  return props.active ? "border-bottom: none; border-top: 4px solid ".concat(props.secondaryColor || "#008a16", ";border-bottom: none;background-color: #F7F7F7;color: ").concat(props.secondaryColor || "#008a16", ";") : '';
}, function (props) {
  return props.disabled ? "opacity: 0.5;" : '';
}, function (props) {
  return (props.preventNavigation || props.disabled) && "pointer-events: none;";
}, function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var TabLabel = styled.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n  @media (max-width: ", "px) {\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var ContentWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0px;\n  padding: 20px 12px 0px 40px;\n  background-color: #F7F7F7;\n  border-top: 1px solid #CCC;\n  border-bottom: 1px solid #CCC;\n  margin-top: -1px;\n  @media (max-width: ", "px) {\n    padding: 10px 2px 0px 20px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var ButtonWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n  padding-bottom: 10px;\n"])));
var ScrollbarsContent = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-right: 16px;\n  flex-direction: column;\n"])));
var OptionsContent = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  @media (max-width: ", "px) {\n    flex-direction: column;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var TopBorder = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  height: 3px;\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n  background-color: white;\n  transition: background-color 250ms, box-shadow 250ms;\n"])));
var CategoryWrapper = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 calc(50% - 10px);\n  padding: 24px;\n  margin-bottom: 15px;\n  margin-right: 10px;\n\n  background: #FFFFFF;\n  border: 1px solid rgba(160, 164, 168, 0.4);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: box-shadow 250ms;\n\n  ", "\n\n  @media (max-width: ", "px) {\n    flex: 1 1 0px;\n    margin-right: 0px;\n  }\n\n  :hover {\n    ", " {\n      background-color: ", ";\n    }\n    box-shadow: 0px 20px 20px -20px rgba(81, 81, 81, 0.72);\n  }\n"])), function (props) {
  return props.disabled && 'opacity 0.75; pointer-events: none;';
}, function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
}, TopBorder, function (props) {
  return props.color || '#008a16';
});
var CategoryTitle = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  color: #2F3136;\n  margin-right: 10px;\n"])));
var CategoryDescriptionAndActionsWrapper = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  flex: 1 1 0px;\n"])));
var CategoryDescription = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  color: #626469;\n  margin-top: 10px;\n"])));
var BreadcrumbWrapper = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 10px;\n  align-items: center;\n\n  @media (max-width: ", "px) {\n    display: none;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var BreadcrumbLink = styled.span(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  color: #0F0F0F;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.disabled && "pointer-events: none;";
}, function (props) {
  return props.isLast ? "color: #626469;" : "\n    cursor: pointer;\n    :hover {\n      text-decoration: underline;\n    }\n  ";
});
var BreadcrumSeparator = styled.span(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  margin: 0px 10px;\n"])));
var BreadcrumbItem = styled.span(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  @media (max-width: ", "px) {\n      display: none;\n    }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var OptionWrapper = styled.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 calc(100%);\n  max-width: calc(100%);\n  padding: 24px 24px 24px 10px;\n  margin-bottom: 15px;\n  margin-right: 10px;\n\n  background: #FFFFFF;\n  border: 1px solid rgba(160, 164, 168, 0.4);\n  border-radius: 4px;\n\n  ", "\n\n  @media (max-width: ", "px) {\n    flex: 1 1 0px;\n    margin-right: 0px;\n  }\n"])), function (props) {
  return props.disabled && 'opacity 0.75; pointer-events: none;';
}, function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var OptionContent = styled.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var SubAccessoriesWrapper = styled.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0px;\n  margin-top: 5px;\n  margin-left: -10px;\n  margin-right: -24px;\n  margin-bottom: -24px;\n"])));
var OptionCol = styled.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  flex-direction: column;\n"])));
var OptionRow = styled.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 5px;\n  justify-content: space-between;\n  align-items: center;\n"])));
var OptionLinkWrapper = styled.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 700;\n"])));
var OptionImage = styled.img(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  width: 80px;\n  height: 80px;\n  margin-right: 10px;\n  @media (max-width: 400px) {\n    width: 50px;\n    height: 50px;\n  }\n"])));
var DescriptionWrapper = styled.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 5px;\n"])));
var OptionDescription = styled.span(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 12px;\n  color: #626469;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n"])));
var ActionButtonWrapper = styled.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  justify-content: flex-end;\n"])));
var LinkWrapper = styled.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
var NumberOfAccessoriesWrapper = styled.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  margin-top: 10px;\n"])));
var OptionCategoryMessageWrapper = styled.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: -15px;\n  margin-right: -14px;\n  min-height: 26px;\n"])));
var ContentCategoryTitle = styled.span(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  color: #2F3136;\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 10px;\n"])));
var SelectOptionTypeTitle = styled.span(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  color: #2F3136;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 10px;\n"])));
var OptionTypesWrapper = styled.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: 10px;\n  min-height: 35px;\n  max-height: 35px;\n  height: 35px;\n  margin-right: 26px;\n  @media (max-width: ", "px) {\n    margin-right: 16px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var ChipWrapper = styled.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n"])));
var WarningLabel = styled.span(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n"])));
var WarningIconWrapper = styled.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  display: flex;\n  min-width: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  max-height: 24px;\n  padding: 2px;\n  color: #B10043;\n  box-sizing: border-box;\n"])));
var OptionSlotsWrapper = styled.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var SlotsTitleAndLineWrapper = styled.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var OptionSlotsLabel = styled.span(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  color: #0F0F0F;\n  font-size: 12px;\n  font-weight: 400;\n  margin-right: 10px;\n"])));
var OptionSlotsLine = styled.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  background: rgba(0, 0, 0, 0.10);\n  height: 1px;\n"])));
var SlotRow = styled.div(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n"])));
var SlotWrapper = styled.div(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  margin-top: 5px;\n  margin-right: 5px;\n"])));
var CategoryTitleAndStatusWrapper = styled.div(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var Col = styled.div(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0px;\n"])));
var ItemImage = styled.img(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  box-sizing: content-box;\n  min-width: 80px;\n  max-width: 80px;\n  width: 80px;\n  min-height: 80px;\n  max-height: 80px;\n  height: 80px;\n  margin-right: 10px;\n\n  @media (max-width: 500px) {\n    display: none;\n  }\n"])));
var TooltipContent = styled.div(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 16px;\n  width: 200px;\n  border-radius: 4px;\n\n"])));
var TooltipLabel = styled.span(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  color: #000;\n  font-size: 16px;\n  font-weight: 400;\n  white-space: pre-wrap;\n"])));

/**
 * Both of these notifications wrapper will not have position relative on purpose.
 */
var DesktopNotifcationWrapper = styled.div(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  display: none;\n  @media (max-width: 500px) {\n    display: block;\n  }\n"])));
var MobileNotificationWrapper = styled.div(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  @media (max-width: 500px) {\n    display: none;\n  }\n"])));
export var active_category_type = {
  accessories: 1,
  services: 2
};
var active_category_to_label = (_active_category_to_l = {}, _defineProperty(_active_category_to_l, active_category_type.accessories, 'options_screen.accessories'), _defineProperty(_active_category_to_l, active_category_type.services, 'options_screen.services'), _active_category_to_l);
var OptionsModal = /*#__PURE__*/function (_React$Component) {
  _inherits(OptionsModal, _React$Component);
  var _super = _createSuper(OptionsModal);
  function OptionsModal(props) {
    var _this;
    _classCallCheck(this, OptionsModal);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      _this.retrieveOptions(true);
    });
    _defineProperty(_assertThisInitialized(_this), "optionsToExplore", function (optionCategories) {
      var optionsToExplore = optionCategories.accessories || [];
      if (_this.state.activeCategory === active_category_type.services) {
        optionsToExplore = optionCategories.services || [];
      }
      return optionsToExplore;
    });
    /**
     *
     * @returns map containing all the visible IDs
     */
    _defineProperty(_assertThisInitialized(_this), "extractVisibleOptionIds", function () {
      var visibleOptionIds = {};
      var stack = [];
      var optionsToExplore = _this.optionsToExplore(_this.state.optionCategories);

      // First step to put the initial elements to explore
      var _iterator = _createForOfIteratorHelper(optionsToExplore),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _optionCategory = _step.value;
          stack.push({
            optionCategory: _optionCategory
          });
        }

        // Unfold the stack
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      while (stack.length > 0) {
        var _stackItem$optionCate;
        var stackItem = stack.pop();
        if ((_stackItem$optionCate = stackItem.optionCategory) !== null && _stackItem$optionCate !== void 0 && _stackItem$optionCate.isFinal) {
          var _iterator2 = _createForOfIteratorHelper(stackItem.optionCategory.options || []),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _option$optionIdentif;
              var option = _step2.value;
              visibleOptionIds[(_option$optionIdentif = option.optionIdentification) === null || _option$optionIdentif === void 0 ? void 0 : _option$optionIdentif.id] = true;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          for (var _i = 0, _Object$keys = Object.keys(stackItem.optionCategory.optionCategories); _i < _Object$keys.length; _i++) {
            var optCategoryKey = _Object$keys[_i];
            var optionCategory = stackItem.optionCategory.optionCategories[optCategoryKey];
            stack.push({
              optionCategory: optionCategory
            });
          }
        }
      }
      return visibleOptionIds;
    });
    _defineProperty(_assertThisInitialized(_this), "computeBreadcrumbForDefaultOptionToView", function (optionCategories, optionId) {
      var breadcrumbStack = [];
      var optionsToExplore = _this.optionsToExplore(optionCategories);

      // First step to put the initial elements to explore
      var _iterator3 = _createForOfIteratorHelper(optionsToExplore),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _optionCategory2 = _step3.value;
          breadcrumbStack.push({
            breadcrumb: [],
            optionCategory: _optionCategory2
          });
        }

        // Unfold the stack
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      while (breadcrumbStack.length > 0) {
        var _stackItem$optionCate2;
        var stackItem = breadcrumbStack.pop();
        if ((_stackItem$optionCate2 = stackItem.optionCategory) !== null && _stackItem$optionCate2 !== void 0 && _stackItem$optionCate2.isFinal) {
          var _iterator4 = _createForOfIteratorHelper(stackItem.optionCategory.options || []),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _option$optionIdentif2;
              var option = _step4.value;
              if (((_option$optionIdentif2 = option.optionIdentification) === null || _option$optionIdentif2 === void 0 ? void 0 : _option$optionIdentif2.id) === optionId) {
                return stackItem.breadcrumb;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } else {
          for (var _i2 = 0, _Object$keys2 = Object.keys(stackItem.optionCategory.optionCategories); _i2 < _Object$keys2.length; _i2++) {
            var optCategoryKey = _Object$keys2[_i2];
            var optionCategory = stackItem.optionCategory.optionCategories[optCategoryKey];
            breadcrumbStack.push({
              breadcrumb: [].concat(_toConsumableArray(stackItem.breadcrumb), [{
                key: optionCategory.categoryKey,
                label: optionCategory.categoryLabel
              }]),
              optionCategory: optionCategory
            });
          }
        }
      }
      return [];
    });
    _defineProperty(_assertThisInitialized(_this), "extractSlots", function () {
      var stack = [];
      var slots = {};
      var visibleOptionIds = _this.extractVisibleOptionIds();
      Object.keys(_this.state.optionCategories).forEach(function (optionCategoryKey) {
        var optCategoryContent = _this.state.optionCategories[optionCategoryKey];
        optCategoryContent.forEach(function (optCategory) {
          Object.values(optCategory.optionCategories || {}).forEach(function (opt) {
            stack.push({
              breadcrumb: [],
              optionCategory: opt,
              optionCategoryKey: optionCategoryKey
            });
          });
        });
      });

      // Unfold the stack
      while (stack.length > 0) {
        var _stackItem$optionCate3;
        var stackItem = stack.pop();
        if ((_stackItem$optionCate3 = stackItem.optionCategory) !== null && _stackItem$optionCate3 !== void 0 && _stackItem$optionCate3.isFinal) {
          var _iterator5 = _createForOfIteratorHelper(stackItem.optionCategory.options || []),
            _step5;
          try {
            var _loop = function _loop() {
              var option = _step5.value;
              (option.slotsConsumed || []).forEach(function (slot) {
                var _option$optionIdentif3;
                if (slots[slot.slotKey] == null) {
                  slots[slot.slotKey] = _objectSpread({}, slot); // Copy of the slot object !
                }

                if (slot.filled) {
                  slots[slot.slotKey].filled = true;
                }
                if (visibleOptionIds[(_option$optionIdentif3 = option.optionIdentification) === null || _option$optionIdentif3 === void 0 ? void 0 : _option$optionIdentif3.id]) {
                  slots[slot.slotKey].visible = true;
                }
              });
            };
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        } else {
          for (var _i3 = 0, _Object$keys3 = Object.keys(stackItem.optionCategory.optionCategories); _i3 < _Object$keys3.length; _i3++) {
            var optCategoryKey = _Object$keys3[_i3];
            var optionCategory = stackItem.optionCategory.optionCategories[optCategoryKey];
            stack.push({
              breadcrumb: [].concat(_toConsumableArray(stackItem.breadcrumb), [{
                key: optionCategory.categoryKey,
                label: optionCategory.categoryLabel
              }]),
              optionCategory: optionCategory,
              optionCategoryKey: stackItem.optionCategoryKey
            });
          }
        }
      }
      return Object.values(slots);
    });
    _defineProperty(_assertThisInitialized(_this), "addOptions", function (deviceIdentification, optionIdentification, quantity) {
      return Promise.resolve(_this.props.onAddOptions(deviceIdentification, optionIdentification, quantity));
    });
    _defineProperty(_assertThisInitialized(_this), "removeOptions", function (deviceIdentification, optionIdentification) {
      return Promise.resolve(_this.props.onRemoveOptions(deviceIdentification, optionIdentification));
    });
    _defineProperty(_assertThisInitialized(_this), "decreaseOptions", function (deviceIdentification, optionIdentification, quantity) {
      return Promise.resolve(_this.props.onDecreaseOptions(deviceIdentification, optionIdentification, quantity));
    });
    _defineProperty(_assertThisInitialized(_this), "addSubAccessories", function (deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity) {
      return Promise.resolve(_this.props.onAddSubAccessories(deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity));
    });
    _defineProperty(_assertThisInitialized(_this), "decreaseSubAccessories", function (deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity) {
      return Promise.resolve(_this.props.onDecreaseSubAccessories(deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity));
    });
    _defineProperty(_assertThisInitialized(_this), "removeSubAccessories", function (deviceIdentification, accessoryIdentification, subAccessoryIdentification) {
      return Promise.resolve(_this.props.onRemoveSubAccessories(deviceIdentification, accessoryIdentification, subAccessoryIdentification));
    });
    _defineProperty(_assertThisInitialized(_this), "filterOptionCategories", function (optionCategories) {
      var result = {};
      Object.keys(optionCategories).forEach(function (key) {
        var optCategory = optionCategories[key];
        if (optCategory.isFinal) {
          // If status to filter is defined, show only accessories from the given status
          optCategory.options = optCategory.options.filter(function (opt) {
            return _this.props.statusToFilter ? opt.status === _this.props.statusToFilter : true;
          });
          if (optCategory.options.length > 0) {
            result[key] = optCategory;
          }
        } else {
          optCategory.optionCategories = _this.filterOptionCategories(optCategory.optionCategories);
          if (Object.keys(optCategory.optionCategories).length > 0) {
            result[key] = optCategory;
          }
        }
      });
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "filterOptionCategoriesPayload", function (optionCategoriesPayload) {
      Object.keys(optionCategoriesPayload).forEach(function (optionCategoryKey) {
        optionCategoriesPayload[optionCategoryKey] = optionCategoriesPayload[optionCategoryKey].filter(function (optionCategoryItem) {
          optionCategoryItem.optionCategories = _this.filterOptionCategories(optionCategoryItem.optionCategories);
          return Object.keys(optionCategoryItem.optionCategories).length > 0;
        });
      });
      return optionCategoriesPayload;
    });
    _defineProperty(_assertThisInitialized(_this), "retrieveOptions", function () {
      var viewDefaultAccessory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.updateStateIfMounted({
        optionsLoading: true
      });
      Promise.resolve(_this.props.getOptions()).then(function (value) {
        var filteredOptionCategories = _this.filterOptionCategoriesPayload(value);
        if (viewDefaultAccessory && _this.props.defaultModalAccessoryToView) {
          var _this$props$defaultMo, _this$props$defaultMo2;
          _this.updateStateIfMounted({
            breadcrumb: _this.computeBreadcrumbForDefaultOptionToView(filteredOptionCategories, (_this$props$defaultMo = _this.props.defaultModalAccessoryToView) === null || _this$props$defaultMo === void 0 ? void 0 : (_this$props$defaultMo2 = _this$props$defaultMo.optionIdentification) === null || _this$props$defaultMo2 === void 0 ? void 0 : _this$props$defaultMo2.id)
          });
          if (_this.props.defaultOptionTypes) {
            var stateCopy = {};
            _this.props.defaultOptionTypes.forEach(function (optType) {
              stateCopy[optType.key] = true;
            });
            _this.updateStateIfMounted({
              selectedOptionTypes: stateCopy
            });
          }

          // Scroll to the desired element (setTimeout is required to trigger the scroll after the first React render, which will initialize the scrollbars references)
          // and put elements in the page.
          setTimeout(function () {
            var elementToScroll = document.getElementById("".concat(_this.props.defaultModalAccessoryToView.id, "-option-modal-category"));
            if (elementToScroll && _this.scrollbarsElement && _this.scrollbarsElement.view) {
              _this.scrollbarsElement.view.scrollTop = elementToScroll.offsetTop || 0;
            }
          }, 0);
        }
        _this.updateStateIfMounted({
          optionCategories: filteredOptionCategories,
          optionsLoading: false
        });
      })["catch"](function (err) {
        console.log('Failed to retrieve the options');
        console.error(err);
      })["finally"](function () {
        _this.updateStateIfMounted({
          optionsLoading: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });
    _defineProperty(_assertThisInitialized(_this), "updateStateIfMounted", function (newState) {
      if (_this._isMounted) {
        _this.setState(newState);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderTypeTabs", function () {
      var _this$state$optionCat, _this$state$optionCat2;
      return /*#__PURE__*/React.createElement(CategoryTabsWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(CategoryTab, {
        id: 'options-modal-accessories-tab',
        primaryColor: _this.props.primaryColor,
        secondaryColor: _this.props.secondaryColor,
        onClick: function onClick() {
          _this.setState({
            activeCategory: active_category_type.accessories,
            breadcrumb: []
          });
        },
        active: active_category_type.accessories === _this.state.activeCategory,
        disabled: (((_this$state$optionCat = _this.state.optionCategories) === null || _this$state$optionCat === void 0 ? void 0 : _this$state$optionCat.accessories) || []).length === 0,
        preventNavigation: _this.props.disablePreviousOnEdit
      }, /*#__PURE__*/React.createElement(TabLabel, null, _this.props.getLabel(active_category_to_label[active_category_type.accessories]))), /*#__PURE__*/React.createElement(CategoryTab, {
        id: 'options-modal-services-tab',
        primaryColor: _this.props.primaryColor,
        secondaryColor: _this.props.secondaryColor,
        onClick: function onClick() {
          _this.setState({
            activeCategory: active_category_type.services,
            breadcrumb: []
          });
        },
        active: active_category_type.services === _this.state.activeCategory,
        disabled: (((_this$state$optionCat2 = _this.state.optionCategories) === null || _this$state$optionCat2 === void 0 ? void 0 : _this$state$optionCat2.services) || []).length === 0,
        preventNavigation: _this.props.disablePreviousOnEdit
      }, /*#__PURE__*/React.createElement(TabLabel, null, _this.props.getLabel(active_category_to_label[active_category_type.services]))));
    });
    _defineProperty(_assertThisInitialized(_this), "extractCurrentOptionCategories", function (slotCategories) {
      var categories = [];
      (slotCategories || []).forEach(function (slotCategory) {
        var currentCategory = slotCategory;
        var _iterator6 = _createForOfIteratorHelper(_this.state.breadcrumb),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var breadcrumbItem = _step6.value;
            currentCategory = currentCategory.optionCategories[breadcrumbItem.key];
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        if (currentCategory.isFinal) {
          currentCategory.options.forEach(function (opt) {
            categories.push({
              optionIdentification: opt.optionIdentification,
              id: opt.id,
              getOptionDescription: opt.getOptionDescription,
              imageUrl: opt.imageUrl,
              canAdd: opt.canAdd,
              canRemove: opt.canRemove,
              canIncrease: opt.canIncrease,
              canDecrease: opt.canDecrease,
              quantity: opt.quantity,
              disabledMessage: opt.disabledMessage,
              status: opt.status,
              statusToolTipMessage: opt.statusToolTipMessage,
              hideStatusTooltip: opt.hideStatusTooltip,
              optionTypes: opt.optionTypes,
              subAccessories: opt.subAccessories,
              slotsConsumed: opt.slotsConsumed,
              isFinal: true
            });
          });
        } else {
          Object.values(currentCategory.optionCategories).forEach(function (category) {
            return categories.push(_objectSpread(_objectSpread({}, category), {}, {
              isFinal: false
            }));
          });
        }
      });
      return categories;
    });
    _defineProperty(_assertThisInitialized(_this), "renderBreadcrumb", function () {
      return /*#__PURE__*/React.createElement(BreadcrumbWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(BreadcrumbLink, {
        disabled: _this.props.disablePreviousOnEdit,
        onClick: function onClick() {
          _this.updateStateIfMounted({
            breadcrumb: [],
            selectedOptionTypes: {}
          });
        }
      }, _this.props.getLabel(active_category_to_label[_this.state.activeCategory])), _this.state.breadcrumb.map(function (breadcrumbItem, idx) {
        return /*#__PURE__*/React.createElement(BreadcrumbItem, {
          mobileBreakpoint: _this.props.mobileBreakpoint,
          key: idx
        }, /*#__PURE__*/React.createElement(BreadcrumSeparator, null, '>'), /*#__PURE__*/React.createElement(BreadcrumbLink, {
          disabled: _this.props.disablePreviousOnEdit,
          isLast: idx === _this.state.breadcrumb.length - 1,
          onClick: function onClick() {
            _this.updateStateIfMounted({
              breadcrumb: _toConsumableArray(_this.state.breadcrumb).splice(0, idx + 1),
              selectedOptionTypes: {}
            });
          }
        }, breadcrumbItem.label));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "extractCategoryInformations", function (category) {
      var nbAccessoriesSelected = 0;
      var hasRecommended = false;
      var categoryStack = [category];

      // Unfold the stack
      while (categoryStack.length > 0) {
        var categoryItem = categoryStack.pop();
        if (categoryItem.options) {
          for (var _i4 = 0, _Object$keys4 = Object.keys(categoryItem.options); _i4 < _Object$keys4.length; _i4++) {
            var optCategoryKey = _Object$keys4[_i4];
            var optionCategory = categoryItem.options[optCategoryKey];
            categoryStack.push(optionCategory);
          }
        } else {
          if (categoryItem.status === 'recommanded') {
            hasRecommended = true;
          }
          nbAccessoriesSelected += categoryItem.quantity || 0;
          if (categoryItem.subAccessories) {
            for (var _i5 = 0, _Object$values = Object.values(categoryItem.subAccessories); _i5 < _Object$values.length; _i5++) {
              var subAccessory = _Object$values[_i5];
              nbAccessoriesSelected += subAccessory.quantity || 0;
            }
          }
        }
      }
      return {
        nbAccessoriesSelected: nbAccessoriesSelected,
        hasRecommended: hasRecommended
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderCategoryCardTopMessage", function (category) {
      var content = /*#__PURE__*/React.createElement(React.Fragment, null);
      var title;
      if (category.warningMessage) {
        title = category.warningMessage;
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WarningIconWrapper, null, /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 1024 1024"
        }, /*#__PURE__*/React.createElement("path", {
          fill: "currentColor",
          d: "M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm-32 150c-8 8-11 20-11 31l11 249c0 9 3 18 10 24 6 5 14 8 22 8 9 0 17-3 23-8 6-6 10-15 9-24l13-249c0-12-5-23-13-31-9-9-20-13-32-13s-24 4-32 13zm67 469v-1c10-9 16-22 15-36 0-13-5-26-15-35-9-9-22-15-35-14-14-1-26 5-36 14-9 9-15 22-14 35-1 14 5 28 15 37 20 18 50 18 70 0z"
        }))), /*#__PURE__*/React.createElement(WarningLabel, {
          title: category.warningMessage
        }, category.warningMessage));
      }
      return /*#__PURE__*/React.createElement(OptionCategoryMessageWrapper, {
        title: title
      }, content);
    });
    _defineProperty(_assertThisInitialized(_this), "renderTooltipContent", function (tooltipMessage) {
      return /*#__PURE__*/React.createElement(TooltipContent, null, /*#__PURE__*/React.createElement(TooltipLabel, null, tooltipMessage));
    });
    _defineProperty(_assertThisInitialized(_this), "renderRecommandedStatus", function (tooltipMessage) {
      var recommandedStatusComponent = /*#__PURE__*/React.createElement(StatusTooltip, {
        fixed: true,
        getLabel: _this.props.getLabel,
        status: 'recommanded'
      });
      if (tooltipMessage) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          boundingElement: _this.scrollbarsWrapperElement,
          toggleElement: recommandedStatusComponent,
          containerElement: _this.renderTooltipContent(tooltipMessage),
          allowTop: true
        });
      }
      return recommandedStatusComponent;
    });
    _defineProperty(_assertThisInitialized(_this), "renderCategory", function (category) {
      var _this$extractCategory = _this.extractCategoryInformations(category),
        nbAccessoriesSelected = _this$extractCategory.nbAccessoriesSelected,
        hasRecommended = _this$extractCategory.hasRecommended;
      return /*#__PURE__*/React.createElement(CategoryWrapper, {
        id: "".concat(category.categoryKey, "-option-modal-category"),
        mobileBreakpoint: _this.props.mobileBreakpoint,
        color: _this.props.secondaryColor,
        onClick: function onClick() {
          _this.updateStateIfMounted({
            breadcrumb: [].concat(_toConsumableArray(_this.state.breadcrumb), [{
              key: category.categoryKey,
              label: category.categoryLabel
            }]),
            selectedOptionTypes: {}
          });
        }
      }, _this.renderCategoryCardTopMessage(category), /*#__PURE__*/React.createElement(CategoryTitleAndStatusWrapper, null, /*#__PURE__*/React.createElement(CategoryTitle, null, category.categoryLabel), hasRecommended && _this.renderRecommandedStatus(category.statusToolTipMessage)), category.categoryDescription && /*#__PURE__*/React.createElement(CategoryDescription, null, category.categoryDescription), nbAccessoriesSelected > 0 && /*#__PURE__*/React.createElement(NumberOfAccessoriesWrapper, null, /*#__PURE__*/React.createElement(StatusTooltip, {
        fixed: true,
        getLabel: _this.props.getLabel,
        message: _this.props.getAndReplaceLabel('options_screen.number_accessories_added', nbAccessoriesSelected, 'nb')
      })), /*#__PURE__*/React.createElement(TopBorder, null));
    });
    _defineProperty(_assertThisInitialized(_this), "raiseNotificationEvent", function (eventType, option, quantity) {
      document.dispatchEvent(new CustomEvent('iac-add-to-notification-feed', {
        bubbles: true,
        detail: {
          identificationKey: _this.props.deviceIdentification.identificationKey,
          status: eventType,
          type: option.type,
          id: option.id,
          slot: option.slot,
          quantity: quantity
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionButton", function (option, addDisabled) {
      return /*#__PURE__*/React.createElement(ActionButtonWrapper, null, option.quantity > 0 && /*#__PURE__*/React.createElement(QuantityEditor, {
        id: option.id,
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        isSaving: _this.props.isSaving,
        quantity: option.quantity,
        canIncrease: option.canIncrease,
        onIncrease: function onIncrease() {
          _this.addOptions(_this.props.deviceIdentification, option.optionIdentification, 1).then(function () {
            _this.raiseNotificationEvent('added', option, 1);
            _this.retrieveOptions(false);
          });
        },
        canDecrease: option.canDecrease && (option.quantity > 1 || option.quantity === 1 && option.canRemove),
        onDecrease: function onDecrease() {
          if (option.quantity === 1 && option.canRemove && _this.props.onRemoveOptions) {
            _this.removeOptions(_this.props.deviceIdentification, option.optionIdentification).then(function () {
              _this.raiseNotificationEvent('removed', option, 1);
              _this.retrieveOptions(false);
            });
          } else {
            if (_this.props.onDecreaseOptions) {
              _this.decreaseOptions(_this.props.deviceIdentification, option.optionIdentification, 1).then(function () {
                _this.raiseNotificationEvent('removed', option, 1);
                _this.retrieveOptions(false);
              });
            }
          }
        }
      }), option.canRemove && option.quantity > 0 && /*#__PURE__*/React.createElement(IconButton, {
        id: "".concat(option.id, "-option-modal-remove"),
        icon: "remove",
        size: 40,
        padding: 7,
        color: '#626469',
        disabled: _this.props.isSaving,
        onClick: function onClick() {
          _this.removeOptions(_this.props.deviceIdentification, option.optionIdentification).then(function () {
            _this.raiseNotificationEvent('removed', option, option.quantity);
            _this.retrieveOptions(false);
          });
        }
      }), option.quantity === 0 && /*#__PURE__*/React.createElement(Button, {
        id: "".concat(option.id, "-option-modal-add"),
        disabled: addDisabled,
        label: _this.props.getLabel('app.action.add'),
        title: option.disabledMessage,
        icon: 'plus-large',
        onClick: function onClick() {
          if (!addDisabled) {
            _this.addOptions(_this.props.deviceIdentification, option.optionIdentification, 1).then(function () {
              _this.raiseNotificationEvent('added', option, 1);
              _this.retrieveOptions(false);
            });
          }
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptionSlots", function (option) {
      return /*#__PURE__*/React.createElement(OptionSlotsWrapper, null, /*#__PURE__*/React.createElement(SlotsTitleAndLineWrapper, null, /*#__PURE__*/React.createElement(OptionSlotsLabel, null, _this.props.getLabel('options_screen.slot_consumed')), /*#__PURE__*/React.createElement(OptionSlotsLine, null)), /*#__PURE__*/React.createElement(SlotRow, null, option.slotsConsumed.map(function (slot, idx) {
        return /*#__PURE__*/React.createElement(SlotWrapper, {
          key: idx
        }, /*#__PURE__*/React.createElement(SlotChip, {
          label: slot.label,
          filled: slot.filled,
          disabled: slot.disabled,
          onClick: function onClick() {
            if (slot.onClick) {
              Promise.resolve(slot.onClick()).then(function () {
                _this.retrieveOptions(false);
              });
            }
          },
          fillColor: _this.props.primaryColor,
          fillTextColor: _this.props.primaryTextColor
        }));
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptionCategory", function (option) {
      var addDisabled = _this.props.isSaving || !option.canAdd;
      var description = option.getOptionDescription();
      return /*#__PURE__*/React.createElement(OptionWrapper, {
        id: "".concat(option.id, "-option-modal-category"),
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(OptionContent, null, /*#__PURE__*/React.createElement(OptionImage, {
        src: option.imageUrl
      }), /*#__PURE__*/React.createElement(CategoryDescriptionAndActionsWrapper, null, /*#__PURE__*/React.createElement(OptionCol, null, /*#__PURE__*/React.createElement(OptionLinkWrapper, null, /*#__PURE__*/React.createElement(LinkWrapper, null, _this.props.renderProductLink(option.id)), option.status === 'recommanded' && !option.hideStatusTooltip && _this.renderRecommandedStatus(option.statusToolTipMessage)), /*#__PURE__*/React.createElement(DescriptionWrapper, null, /*#__PURE__*/React.createElement(OptionDescription, {
        title: description
      }, description))), /*#__PURE__*/React.createElement(OptionRow, null, _this.renderActionButton(option, addDisabled)))), option.slotsConsumed && option.slotsConsumed.length > 0 && _this.renderOptionSlots(option), option.subAccessories && Object.keys(option.subAccessories).length > 0 && /*#__PURE__*/React.createElement(SubAccessoriesWrapper, null, /*#__PURE__*/React.createElement(SubAccessoriesManager, {
        deviceIdentification: _this.props.deviceIdentification,
        accessoryIdentification: option.optionIdentification,
        option: option,
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        isSaving: _this.props.isSaving,
        renderProductLink: _this.props.renderProductLink,
        subAccessories: option.subAccessories,
        getLabel: _this.props.getLabel,
        getAndReplaceLabel: _this.props.getAndReplaceLabel,
        mobileBreakpoint: _this.props.mobileBreakpoint,
        onAddSubAccessories: _this.addSubAccessories,
        onDecreaseSubAccessories: _this.decreaseSubAccessories,
        onRemoveSubAccessories: _this.removeSubAccessories,
        raiseNotificationEvent: _this.raiseNotificationEvent,
        retrieveOptions: function retrieveOptions() {
          _this.retrieveOptions(false);
        }
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "extractCategoriesToShow", function () {
      var categoriesToShow;
      if (active_category_type.accessories === _this.state.activeCategory) {
        var _this$state$optionCat3;
        categoriesToShow = _this.extractCurrentOptionCategories((_this$state$optionCat3 = _this.state.optionCategories) === null || _this$state$optionCat3 === void 0 ? void 0 : _this$state$optionCat3.accessories).filter(function (optCategory) {
          var showCategory = true;
          if (optCategory.optionTypes && Object.keys(_this.state.selectedOptionTypes).length > 0) {
            var atLeastOneCategoryFound = false;
            for (var i = 0; i < optCategory.optionTypes.length && !atLeastOneCategoryFound; i++) {
              if (_this.state.selectedOptionTypes[optCategory.optionTypes[i].key]) {
                atLeastOneCategoryFound = true;
              }
            }
            showCategory = atLeastOneCategoryFound;
          }
          return showCategory;
        });
      } else if (active_category_type.services === _this.state.activeCategory) {
        var _this$state$optionCat4;
        categoriesToShow = _this.extractCurrentOptionCategories((_this$state$optionCat4 = _this.state.optionCategories) === null || _this$state$optionCat4 === void 0 ? void 0 : _this$state$optionCat4.services).filter(function (optCategory) {
          var showCategory = true;
          if (optCategory.optionTypes && Object.keys(_this.state.selectedOptionTypes).length > 0) {
            var atLeastOneCategoryFound = false;
            for (var i = 0; i < optCategory.optionTypes.length && !atLeastOneCategoryFound; i++) {
              if (_this.state.selectedOptionTypes[optCategory.optionTypes[i].key]) {
                atLeastOneCategoryFound = true;
              }
            }
            showCategory = atLeastOneCategoryFound;
          }
          return showCategory;
        });
      }
      return categoriesToShow;
    });
    /**
     * Sort the option categories, option categories with a recommanded options should appear first.
     */
    _defineProperty(_assertThisInitialized(_this), "sortOptionCategories", function (categories) {
      var result = [];
      var resultWithoutRecommanded = [];
      categories.forEach(function (cat) {
        var categoryInformations = _this.extractCategoryInformations(cat);
        if (categoryInformations.hasRecommended) {
          result.push(cat);
        } else {
          resultWithoutRecommanded.push(cat);
        }
      });
      return [].concat(result, resultWithoutRecommanded);
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptionsContent", function (categories) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, _this.state.optionsLoading && Object.keys(_this.state.optionCategories).length === 0 ? /*#__PURE__*/React.createElement(Skeleton, {
        mobileBreakpoint: _this.props.mobileBreakpoint,
        nbCols: 6
      }) : _this.sortOptionCategories(categories).map(function (category, idx) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: idx
        }, category.isFinal ? _this.renderOptionCategory(category) : _this.renderCategory(category));
      }));
    });
    // Extract the distinct option types. We get rid of the duplicate option types keys.
    _defineProperty(_assertThisInitialized(_this), "extractOptionTypes", function () {
      var optionTypes = {};
      var optionCategories = _this.extractCurrentOptionCategories(_this.optionsToExplore(_this.state.optionCategories));
      optionCategories.forEach(function (optCategory) {
        (optCategory.optionTypes || []).forEach(function (optType) {
          optionTypes[optType.key] = optType;
        });
      });
      return Object.values(optionTypes);
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptionTypes", function (optionTypes) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectOptionTypeTitle, null, _this.props.getLabel('options_screen.select_type')), /*#__PURE__*/React.createElement(OptionTypesWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(Scrollbars, null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, optionTypes.map(function (optType, idx) {
        var selected = _this.state.selectedOptionTypes[optType.key] === true;
        return /*#__PURE__*/React.createElement(ChipWrapper, {
          key: idx
        }, /*#__PURE__*/React.createElement(Chip, {
          disabled: false,
          title: optType.label,
          value: optType.key,
          selected: selected,
          onClick: function onClick() {
            var stateCopy = _objectSpread({}, _this.state.selectedOptionTypes);
            if (selected) {
              delete stateCopy[optType.key];
            } else {
              stateCopy[optType.key] = true;
            }
            _this.updateStateIfMounted({
              selectedOptionTypes: stateCopy
            });
          }
        }));
      })))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSlotCapacities", function (hasFinal) {
      var slots = _this.extractSlots();
      return /*#__PURE__*/React.createElement(React.Fragment, null, slots.length > 0 && /*#__PURE__*/React.createElement(SlotCapacities, {
        getLabel: _this.props.getLabel,
        slots: slots,
        fillColor: _this.props.primaryColor,
        fillTextColor: _this.props.primaryTextColor,
        forceDisable: !hasFinal
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "setScrollbarsWrapperRef", function (element) {
      _this.scrollbarsWrapperElement = element;
    });
    _defineProperty(_assertThisInitialized(_this), "setScrollbarsRef", function (element) {
      _this.scrollbarsElement = element;
    });
    _this.state = {
      activeCategory: props.defaultActiveCategoryType || active_category_type.accessories,
      optionCategories: {},
      breadcrumb: [],
      optionsLoading: false,
      selectedOptionTypes: {}
    };
    _this._isMounted = true;
    return _this;
  }
  _createClass(OptionsModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var optionTypes = this.extractOptionTypes();
      var categoriesToShow = this.extractCategoriesToShow();

      // Check if we have a final
      var hasFinal = categoriesToShow.filter(function (cat) {
        return cat.isFinal;
      }).length > 0;
      return /*#__PURE__*/React.createElement(ModalContainer, null, /*#__PURE__*/React.createElement(Container, {
        mobileBreakpoint: this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(DesktopNotifcationWrapper, null, /*#__PURE__*/React.createElement(ModalNotification, null)), /*#__PURE__*/React.createElement(HeadWrapper, {
        mobileBreakpoint: this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(ImageAndHeadWrapper, null, /*#__PURE__*/React.createElement(ItemImage, {
        src: this.props.imageUrl
      }), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(TitleAndCloseWrapper, null, /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(TitleType, null, this.props.titleType), /*#__PURE__*/React.createElement(TitleType, null, ":"), /*#__PURE__*/React.createElement(TitleLinkWrapper, null, this.props.renderProductLink(this.props.moduleId))), /*#__PURE__*/React.createElement(CloseIcon, {
        id: 'options-modal-close',
        mobileBreakpoint: this.props.mobileBreakpoint,
        onClick: function onClick() {
          _this2.props.closeModal();
        }
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M590.3,512l290.2,290.2c20.5,20.5,20.5,56.5,0,77.1c-12.8,10.3-25.7,15.4-38.5,15.4c-15.4,0-28.3-5.1-41.1-15.4L513.3,589.1  L223,879.3c-12.8,10.3-25.7,15.4-38.5,15.4c-15.4,0-28.3-5.1-41.1-15.4c-20.5-20.5-20.5-56.5,0-77.1L433.7,512L143.4,221.8  c-20.5-20.5-20.5-56.5,0-77.1c23.1-20.5,56.5-20.5,79.6,0l290.2,287.7L801,144.7c23.1-20.5,56.5-20.5,79.6,0  c20.5,20.5,20.5,56.5,0,77.1L590.3,512z"
      })))), !this.state.optionsLoading && this.renderSlotCapacities(hasFinal))), this.state.activeCategory != null && this.renderBreadcrumb(), this.renderTypeTabs()), /*#__PURE__*/React.createElement(ContentWrapper, {
        mobileBreakpoint: this.props.mobileBreakpoint,
        ref: this.setScrollbarsWrapperRef
      }, /*#__PURE__*/React.createElement(MobileNotificationWrapper, null, /*#__PURE__*/React.createElement(ModalNotification, null)), this.state.breadcrumb.length > 0 && /*#__PURE__*/React.createElement(ContentCategoryTitle, null, this.state.breadcrumb[this.state.breadcrumb.length - 1].label), optionTypes.length > 0 && this.renderOptionTypes(optionTypes), /*#__PURE__*/React.createElement(Scrollbars, {
        ref: this.setScrollbarsRef
      }, /*#__PURE__*/React.createElement(ScrollbarsContent, null, /*#__PURE__*/React.createElement(OptionsContent, {
        mobileBreakpoint: this.props.mobileBreakpoint
      }, this.renderOptionsContent(categoriesToShow))))), this.state.breadcrumb.length > 0 && !this.props.disablePreviousOnEdit && /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
        id: 'options-modal-previous-button',
        color: this.props.primaryColor,
        textColor: this.props.primaryTextColor,
        label: this.props.getLabel('app.action.previous'),
        onClick: function onClick() {
          _this2.updateStateIfMounted({
            breadcrumb: _toConsumableArray(_this2.state.breadcrumb).slice(0, -1),
            selectedOptionTypes: {}
          });
        }
      }))), /*#__PURE__*/React.createElement(NotificationFeed, {
        moduleId: this.props.moduleId,
        primaryColor: this.props.primaryColor,
        primaryTextColor: this.props.primaryTextColor,
        isSaving: this.props.isSaving,
        renderProductLink: this.props.renderProductLink,
        getLabel: this.props.getLabel,
        getAndReplaceLabel: this.props.getAndReplaceLabel,
        mobileBreakpoint: this.props.mobileBreakpoint
      }));
    }
  }]);
  return OptionsModal;
}(React.Component);
_defineProperty(OptionsModal, "propTypes", {
  getLabel: PropTypes.func,
  getAndReplaceLabel: PropTypes.func,
  titleType: PropTypes.string,
  moduleId: PropTypes.string,
  mobileBreakpoint: PropTypes.number,
  getOptions: PropTypes.func,
  closeModal: PropTypes.func,
  imageUrl: PropTypes.string,
  primaryColor: PropTypes.string,
  primaryTextColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  secondaryTextColor: PropTypes.string,
  renderProductLink: PropTypes.func,
  defaultActiveCategoryType: PropTypes.number,
  defaultModalAccessoryToView: PropTypes.object,
  defaultOptionTypes: PropTypes.array,
  onAddOptions: PropTypes.func,
  onRemoveOptions: PropTypes.func,
  onDecreaseOptions: PropTypes.func,
  onAddSubAccessories: PropTypes.func,
  onDecreaseSubAccessories: PropTypes.func,
  onRemoveSubAccessories: PropTypes.func,
  deviceIdentification: PropTypes.object,
  isSaving: PropTypes.bool,
  statusToFilter: PropTypes.string,
  disablePreviousOnEdit: PropTypes.bool
});
export default OptionsModal;